// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";
import { toFormBody } from "./utils";

/** 系统登录 使用表单提交用户名和密码登录，成功后返回 JWT Token POST /login */
export async function formLogin(
  body: API.UserModel,
  options?: { [key: string]: any }
) {
  return request<API.ResultLogin>("/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: toFormBody(body),
    ...(options || {}),
  });
}

/** 退出登录 退出登录 POST /logout */
export async function logout(options?: { [key: string]: any }) {
  return request<API.RequestResult>("/logout", {
    method: "POST",
    ...(options || {}),
  });
}

/** 更新 Token JWT 更新 Token POST /token */
export async function token(options?: { [key: string]: any }) {
  return request<API.ResultLogin>("/token", {
    method: "POST",
    ...(options || {}),
  });
}
